import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image, Platform } from 'react-native';
import notificationIcon from '../../assets/notification1.png';
import backIcon from '../../assets/back1.png';
import { useNavigation } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';

export default function TopGreenHeader({
  Heading,
  navigation,
  isBackIcon,
  isNotification,
  client,
  onUserPress,
}) {

  // console.log("This is the selected client", client);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.leftContainer}>
          {isBackIcon && (
            <TouchableOpacity
              style={styles.backButton}
              onPress={() => navigation.goBack()}>
              <Image source={backIcon} style={styles.backIcon} />
            </TouchableOpacity>
          )}
          <TouchableOpacity onPress={onUserPress ? onUserPress : () => navigation.navigate('Profile')}>
            {client &&
              <View style={[styles.userInfoContainer, isBackIcon && { marginLeft: 15 }]}>
                <Text style={styles.signedInText}>Signed in as</Text>
                <Text style={styles.userNameText}>{client}</Text>
              </View>
            }
          </TouchableOpacity>
        </View>
        <Text style={styles.headerText}>{Heading}</Text>
        <View>
          {isNotification && (
            <TouchableOpacity onPress={() => navigation.navigate('Notification')}>
              <Image
                source={notificationIcon}
                style={styles.notificationIcon}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
  },
  header: {
    backgroundColor: '#A6CE39',
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  headerText: {
    color: '#fff',
    fontSize: 24,
    fontFamily: Platform.OS === "android" ? "FacebookSansBold" : "Facebook Sans",
    fontStyle: "normal",
    textAlign: 'center',
    flex: 1,
  },
  leftContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  userInfoContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  signedInText: {
    color: '#ffffff',
    fontSize: 10,
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
  },
  userNameText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: Platform.OS === "android" ? "FacebookSansRegular" : "Facebook Sans",
  },
  backIcon: {
    width: 20,
    height: 20,
  },
  notificationIcon: {
    width: 28,
    height: 32,
    position: 'absolute',
    right: 10,
    bottom: -17,
  },
  calendar: {
    margin: 10,
    borderRadius: 10,
  },
  calendarDay: {
    alignItems: 'center',
  },
  dayText: {
    fontSize: 6,
  },
  descriptionText: {
    fontSize: 12,
    color: '#1A1A1A',
    marginTop: 4,
    textAlign: 'center',
  },
  fabRight: {
    position: 'absolute',
    bottom: 90,
    right: 20,
    width: 60,
    height: 60,
    backgroundColor: '#FF69B4',
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
